(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivities', rmsActivities);

    function rmsActivities() {
        return {
            restrict: 'E',
            scope: {
                activityOptions: '='
            },
            templateUrl: 'common/app/components/activities/list-panel/activities-wrapper',
            controller: rmsActivitiesCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function rmsActivitiesCtrl(ActivitiesService, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.inputModel = {};
            ActivitiesService.init(vm, vm.activityOptions);

            $scope.$on('$destroy', function() {
                ActivitiesService.destroy();
            });
        }
    }
})();